import { Button, Grid, Typography, Stack } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import Paper from '@mui/material/Paper';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import { alertMsg } from '../../utils/basicUtils';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import Empty from '../../components/Empty';
import { useTheme } from '@emotion/react';
import useAxiosPrivate from '../../hooks/use-axios-private';
import SaveAsOutlinedIcon from '@mui/icons-material/SaveAsOutlined';
import Popup from '../../components/Popup';
import StrictNumberField from '../../components/StrictNumberField';
import { APP_CURRENCY } from '../../constants';

const TURNAROUNDTIMEVALUES = {
    "image_count": 0,
    "turn_around_time_lst": [
        {
            "duration": 0,
            "price": 0
        },
        {
            "duration": 0,
            "price": 0
        },
        {
            "duration": 0,
            "price": 0
        }
    ]
}

const createTurnAroundTimeValidation = Yup.object({
    image_count: Yup.number()
        .required('Image count is required')
        .min(1, 'Image count should be greater than or equal to 1')
        .max(10000, 'Image count cannot exceed 10000')
        .integer("Image count must be an integer"),
    price_1: Yup.number()
        .required('Price is required')
        .min(0, 'Price should be greater than or equal to 0')
        .max(10000, 'Price cannot exceed 10000'),
    duration_1: Yup.number()
        .required('Duration is required')
        .min(1, 'Duration should be greater than or equal to 0'),
        // .max(24, 'Duration cannot exceed 24'),
    price_2: Yup.number()
        .required('Price is required')
        .min(0, 'Price should be greater than or equal to 0')
        .max(10000, 'Price cannot exceed 10000'),
    duration_2: Yup.number()
        .required('Duration is required')
        .min(1, 'Duration should be greater than or equal to 1'),
        // .max(24, 'Duration cannot exceed 24'),
    price_3: Yup.number()
        .required('Price is required')
        .min(0, 'Price should be greater than or equal to 0'),
        // .max(10000, 'Price cannot exceed 10000'),
    duration_3: Yup.number()
        .required('Duration is required')
        .min(1, 'Duration should be greater than or equal to 1'),
        // .max(24, 'Duration cannot exceed 24'),
})

const TurnAroundRow = ({ turnAroundData, onDeleteComplete, onUpdate }) => {
    const [editMode, setEditMode] = useState(!!!turnAroundData.id)
    const turnAroundInitialValues = {
        image_count: turnAroundData.image_count,
        price_1: turnAroundData.turn_around_time_lst[0].price,
        duration_1: turnAroundData.turn_around_time_lst[0].duration,
        price_2: turnAroundData.turn_around_time_lst[1].price,
        duration_2: turnAroundData.turn_around_time_lst[1].duration,
        price_3: turnAroundData.turn_around_time_lst[2].price,
        duration_3: turnAroundData.turn_around_time_lst[2].duration,
    }
    const axios = useAxiosPrivate()
    return (
        <Formik
            initialValues={turnAroundInitialValues}
            enableReinitialize={true}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true)
                const data = {
                    "id": turnAroundData.id,
                    "image_count": values.image_count,
                    "turn_around_time_lst": [
                        {
                            "id": turnAroundData.turn_around_time_lst[0].id,
                            "duration": values.duration_1,
                            "price": values.price_1
                        },
                        {
                            "id": turnAroundData.turn_around_time_lst[1].id,
                            "duration": values.duration_2,
                            "price": values.price_2
                        },
                        {
                            "id": turnAroundData.turn_around_time_lst[2].id,
                            "duration": values.duration_3,
                            "price": values.price_3
                        }
                    ]
                }

                let resp = false
                if (!!turnAroundData.id) {
                    try {
                        resp = await axios.put(`jobs/update_turn_around_time/`, data)
                        setEditMode(false)
                    } catch (e) {
                        console.error("🚀 ~ file: TurnAroundTime.jsx:122 ~ onSubmit={ ~ e:", e)
                        alertMsg('Failed to update turnAroundTime', 'error')
                        return
                    }
                } else {
                    try {
                        resp = await axios.post('jobs/turn_around_time/', data)
                        setEditMode(false)
                    } catch (e) {
                        console.error("🚀 ~ file: TurnAroundTime.jsx:130 ~ onSubmit={ ~ e:", e)
                        alertMsg('Failed to create turnAroundTime', 'error')
                        return
                    }
                }
                setSubmitting(false);
                onUpdate();
                alertMsg(resp.data.message, 'success')
            }}
            validationSchema={createTurnAroundTimeValidation}
        >
            {({ submitForm, isSubmitting }) => (
                <Form>
                    <Grid container sx={{ py: 2, minWidth: 800, borderBottom: "1px solid lightgrey" }} spacing={{ xs: 3, sm: 4, md: 6 }} alignItems="stretch">
                        <Grid item xs={3} sx={{ display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: 'center' }} >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", pl: 2 }}>
                                <StrictNumberField name="image_count" label="Image Count" inputProps={{ min: 0 }}
                                    size='small' disabled={!editMode} component={TextField} type="number" fullWidth />
                            </Box>
                        </Grid>
                        <Grid item xs={2} >
                            <Box >
                                <Box sx={{ mb: 2 }}>
                                    <StrictNumberField sx={{ mb: 2 }} name="price_1" label="Price" inputProps={{ min: 0 }}
                                        size='small' disabled={!editMode} component={TextField} type="number" fullWidth />
                                </Box>
                                <Box>
                                    <StrictNumberField name="duration_1" label="Duration (Hrs)" inputProps={{ min: 0 }}
                                        size='small' disabled={!editMode} component={TextField} type="number" fullWidth />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box>
                                <Box sx={{ mb: 2 }}>
                                    <StrictNumberField sx={{ mb: 2 }} name="price_2" label="Price" inputProps={{ min: 0 }}
                                        size='small' disabled={!editMode} component={TextField} type="number" fullWidth />
                                </Box>
                                <Box>
                                    <StrictNumberField name="duration_2" label="Duration (Hrs)" inputProps={{ min: 0 }}
                                        size='small' disabled={!editMode} component={TextField} type="number" fullWidth />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box>
                                <Box sx={{ mb: 2 }}>
                                    <StrictNumberField sx={{ mb: 2 }} name="price_3" label="Price" inputProps={{ min: 0 }}
                                        size='small' disabled={!editMode} component={TextField} type="number" fullWidth />
                                </Box>
                                <Box>
                                    <StrictNumberField name="duration_3" label="Duration (Hrs)" inputProps={{ min: 0 }}
                                        size='small' disabled={!editMode} component={TextField} type="number" fullWidth />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={3} sx={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                            {editMode ?
                                <Stack direction='row' justifyContent='center' alignItems='center'>
                                    <Button sx={{ display: "flex", alignItems: "center", ml: 1 }} onClick={submitForm}>
                                        <Box sx={{ width: "24px", height: "24px" }}>
                                            <SaveAsOutlinedIcon sx={{ fontSize: "24px" }} />
                                        </Box>
                                        <Box>
                                            <Typography sx={{ fontSize: "15px", ml: 1, textTransform: "capitalize" }} >Save</Typography>
                                        </Box>
                                    </Button>
                                </Stack>
                                :
                                <Stack direction='row' justifyContent='center' flexWrap='wrap' alignItems='center'>
                                    <Button sx={{ display: "flex", alignItems: "center", ml: 1 }} onClick={() => setEditMode(true)}>
                                        <Box sx={{ width: "24px", height: "24px" }}>
                                            <EditOutlinedIcon sx={{ fontSize: "24px" }} />
                                        </Box>
                                        <Box>
                                            <Typography sx={{ fontSize: "15px", ml: 1, textTransform: "capitalize" }} >Edit</Typography>
                                        </Box>
                                    </Button>
                                    <Button color="error" sx={{ display: "flex", alignItems: "center", ml: 1 }} onClick={onDeleteComplete}>
                                        <Box sx={{ width: "24px", height: "24px" }}>
                                            <DeleteOutlineOutlinedIcon sx={{ fontSize: "24px" }} />
                                        </Box>
                                        <Box>
                                            <Typography sx={{ fontSize: "15px", ml: 1, textTransform: "capitalize" }}>Delete</Typography>
                                        </Box>
                                    </Button>
                                </Stack>
                            }
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    )
}

const TurnAroundTime = () => {
    const theme = useTheme()
    const axios = useAxiosPrivate()

    const [showAlert, setShowAlert] = useState(false);
    const initialTurnAroundTimeValues = {
        duration: '',
        price: '',
    }
    const [turnAroundTimeObj, setTurnAroundTimeObj] = useState(initialTurnAroundTimeValues)

    const [rows, setRows] = useState([])

    useEffect(() => {
        getTurnAroundTimeList()
    }, [])

    const getTurnAroundTimeList = async () => {
        try {
            let resp = await axios.get('jobs/turn_around_time/');
            setRows(resp.data.data.turn_around_lst)
        }
        catch (err) {
            console.error(err)
        }
    }
    const deleteTurnAroundTime = async (id) => {
        try {
            let resp = await axios.delete('jobs/turn_around_time/' + id)
            getTurnAroundTimeList()
            alertMsg(resp.data.message, 'success')
        } catch (e) {
            console.error("🚀 ~ file: TurnAroundTime.jsx:311 ~ deleteTurnAroundTime ~ e:", e)
            alertMsg('Failed to delete', 'error')
        }
    }
    return (
        <Box sx={{}}>
            <>
                <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'start', sm: 'center' }} justifyContent="space-between" spacing={2} sx={{ mb: 3 }}>
                    <Box sx={{ width: '100%' }}>
                        <Typography sx={{ fontSize: { xs: 18, xl: 20 }, fontWeight: 500, color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Turn Around Time</Typography>
                    </Box>
                    <Box sx={{ width: '100%', }}>
                        <Box sx={{ textAlign: 'right', whiteSpace: 'noWrap' }}>
                            <Button
                                variant='outlined'
                                onClick={() => {
                                    setTurnAroundTimeObj(initialTurnAroundTimeValues)
                                    setRows(prev => ([...prev, TURNAROUNDTIMEVALUES]))
                                }}
                            >Create TurnAroundTime</Button>
                        </Box>
                    </Box>
                </Stack>

                <Paper sx={{ mt: 3, boxShadow: "2px 2px 12px 0px rgb(0 0 0 / 11%)", overflow: "auto", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }} className="overflow-scroll">
                    {rows.length > 0
                        ?
                        <Box>
                            <Grid container spacing={{ xs: 3, sm: 4, md: 6 }} sx={{ py: 2, minWidth: 800, borderBottom: "1px solid lightgrey" }}>
                                <Grid item xs={3} sx={{ textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Image Count</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Price 1 ({APP_CURRENCY.currency_symbol})</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Price 2 ({APP_CURRENCY.currency_symbol})</Typography>
                                </Grid>
                                <Grid item xs={2} sx={{ textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Price 3 ({APP_CURRENCY.currency_symbol})</Typography>
                                </Grid>
                                <Grid item xs={3} sx={{ textAlign: 'center' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>Actions</Typography>
                                </Grid>
                            </Grid>
                            {rows.map((turnAroundData, index) => <TurnAroundRow
                                key={index}
                                onUpdate={getTurnAroundTimeList}
                                turnAroundData={turnAroundData}
                                onDeleteComplete={() => {
                                    setShowAlert(true)
                                    setTurnAroundTimeObj({ ...turnAroundData })
                                }}
                            />
                            )}
                        </Box>
                        :
                        <Empty icon={<ManageAccountsOutlinedIcon sx={{ fontSize: 40, color: "grey" }} />} sx={{ border: 0, pb: 0, }} text="No turn around time available" />
                    }
                    <Popup show={showAlert} onSecondaryClick={() => setShowAlert(false)} title={"Delete Turn Around Time?"} consent={true} variant='error' primaryBtnTxt={"Delete"}
                        onPrimaryClick={async (e, loader) => {
                            if (e.detail !== 1) {
                                return false
                            }
                            try {
                                loader(true)
                                await deleteTurnAroundTime(turnAroundTimeObj.id)
                                setShowAlert(false)
                                loader(false)
                            }
                            catch (error) {
                                console.error(error)
                            }
                        }}
                    >
                        <Box sx={{ mt: 2, textAlign: "center" }}>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure you want to delete</Typography>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>  </Typography>
                            <Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>base Preferences?</Typography>
                        </Box>
                        <Box sx={{ marginTop: "6px", textAlign: "center" }}>
                            <Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
                        </Box>
                    </Popup>
                </Paper>
            </>
        </Box>
    )
}

export default TurnAroundTime